import { Booking } from '../../../logic/api';

export function filterUniqueCustomers(bookings: Booking[]): Booking[] {
  if (!bookings || !Array.isArray(bookings)) {
    return [];
  }

  const uniqueRecords = new Map<string, Booking>();
  bookings.forEach((booking) => {
    const key = `${booking.leadContact.lastName}-${booking.vehicle.registration}`;
    if (!uniqueRecords.has(key)) {
      uniqueRecords.set(key, booking)
    }
  });

  return Array.from(uniqueRecords.values())
}
